import { useLanguage } from "@/contexts/LanguageContext";

const SUITE_IMG = "https://d2xsxph8kpxj0f.cloudfront.net/111011785/VdQVYstYWxPmJs2memuh7b/mockup_trust_management_0c71fb77.png";

export default function Modules() {
  const { t } = useLanguage();

  return (
    <section id="moduli" className="py-24 px-6 border-b border-white/10 max-w-6xl mx-auto" data-testid="modules-section">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
        <div>
          <span className="text-xs font-mono-code text-[#E2C079] uppercase tracking-widest block mb-2">{t.modules.eyebrow}</span>
          <h2 className="font-serif-didot text-3xl sm:text-4xl text-white">{t.modules.title}</h2>
        </div>
        <p className="text-sm text-white/60 max-w-sm">{t.modules.lead}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {t.modules.featured.map((f, i) => (
          <div
            key={f.title}
            className="p-6 rounded border border-white/10 bg-[#0f1b29]/60 hover:border-[#E2C079]/50 transition-colors"
            data-testid={`module-featured-${i}`}
          >
            <h3 className="text-base font-semibold text-white mb-2">{f.title}</h3>
            <p className="text-xs text-white/60 leading-relaxed">{f.text}</p>
          </div>
        ))}
      </div>

      <div
        className="mt-8 rounded border border-white/10 relative overflow-hidden"
        style={{ background: "radial-gradient(100% 100% at 50% 0%, #223C54 0%, #0b131e 100%)" }}
        data-testid="modules-suite-band"
      >
        <div className="relative">
          <img src={SUITE_IMG} alt={t.modules.bandAlt} className="w-full opacity-90" loading="lazy" data-testid="modules-suite-image" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0b131e] via-transparent to-transparent"></div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center font-mono-code text-xs p-8 pt-4">
          {t.modules.chips.map((chip, i) => (
            <div key={chip} className="p-3 bg-white/5 rounded border border-white/5 text-white/80" data-testid={`module-chip-${i}`}>
              {chip}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
